const store = {
    namespaced: true,
    state() {
        return {
            products: [],
            productsId: [],
            showNotification: false,
            removed: false,
            isFetchingFavorites: true,
            favoritesData: null
        };
    },
    getters: {
        getIsShowNotification(state) {
            return state.showNotification;
        },
        getIsRemoved(state) {
            return state.removed;
        },
        getProducts(state) {
            return state.products;
        },
        getProductsIds(state) {
            return state.productsId;
        },
        getProductsLength(state) {
            if (state.productsId) {
                return state.productsId.length;
            }
            return 0;
        },
        getIsFetchingFavorites(state) {
            return state.isFetchingFavorites;
        },
        getFavoritesData(state) {
            return state.favoritesData;
        }
    },
    mutations: {
        setProductIdToFav(state, id) {
            const parsedId = parseFloat(id);
            if (state.productsId.includes(parsedId)) {
                state.productsId = state.productsId.filter(productId => parseFloat(productId) !== parsedId);
                state.products = state.products.filter(product => parseFloat(product.productId) !== parsedId);
            } else {
                state.productsId.push(parsedId);
            }

            this.$cookies.set('favorites', JSON.stringify(state.productsId));
            localStorage.setItem('favorites', JSON.stringify(state.productsId));
        },
        setRemoved(state, value) {
            state.removed = value;
        },
        setIsShowNotification(state, value) {
            state.showNotification = value;
        },
        removeProducts(state) {
            state.products = [];
            state.productsId = [];
            this.$cookies.remove('favorites');
            localStorage.removeItem('favorites');
        },
        initFavProducts(state, products) {
            state.productsId = products;
        },
        setProducts(state, products) {
            state.products = products;
        },
        setIsFetchingFavorites(state, value) {
            state.isFetchingFavorites = value;
        },
        SET_FAVORITES_DATA(state, value) {
            state.favoritesData = value;
        }
    },
    actions: {
        addProductToFav(context, id) {
            context.commit('setProductIdToFav', id);
            context.commit('setIsShowNotification', true);

            setTimeout(() => {
                context.commit('setIsShowNotification', false);
            }, 1000);
        },
        removeProductToFav(context, id) {
            context.commit('setProductIdToFav', id);
            context.commit('setRemoved', true);
            context.commit('setIsShowNotification', true);

            setTimeout(() => {
                context.commit('setIsShowNotification', false);
                context.commit('setRemoved', false);
            }, 1000);
        },
        async fetchFavoritesProducts({ state, commit }, data) {
            if (state.productsId.length === 0) {
                commit('setIsFetchingFavorites', false);

                return;
            }

            const ids = state.productsId?.join(',');
            commit('setIsFetchingFavorites', true);

            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/general/product-filter?ids=${ids}`,
                    params: {
                        pagination: true,
                        page: data?.page || 1
                    }
                });

                commit('setProducts', res.data?.data);
                commit('SET_FAVORITES_DATA', res.data);
                commit('setIsFetchingFavorites', false);
            } catch (e) {
                console.error(e);
            }
        }
    }
};

export default store;
